import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ReturnReasonState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/return-reason";
import { BadgeRedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoTagsDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-tags-dropdown-input";
import { memo, useContext, useMemo } from "react";
import { FlowOptionsContext } from "../condition";

export const ReturnReasonDetails = memo(function ReturnReasonDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<ReturnReasonState>) {
  const flowOptions = useContext(FlowOptionsContext);

  const options: BadgeRedoListItem<string>[] = useMemo(() => {
    const reasonOptions =
      flowOptions?.returnReasonOptions || flowOptions?.claimReasonOptions || [];
    return reasonOptions.map((reason) => ({
      type: "badge" as const,
      id: reason,
      value: reason,
      badge: { text: reason, color: "gray" as const },
    }));
  }, [flowOptions]);

  const selectedOptions: BadgeRedoListItem<string>[] = useMemo(() => {
    return state.map((reason) => ({
      type: "badge" as const,
      id: reason,
      value: reason,
      badge: { text: reason, color: "gray" as const },
    }));
  }, [state]);

  return (
    <RedoTagsDropdownInput
      description="Condition applies to the return item if any of the selected reasons are chosen."
      disabled={disabled}
      label="Return reasons"
      options={options}
      placeholder="Select return reasons..."
      selectedOptions={selectedOptions}
      setSelectedOptions={(items) => {
        setState(items.map((item) => item.value));
      }}
      size="xs"
    />
  );
});
